export const transition1 = {
    duration: 1.4,
    ease: [0.6, 0.01, -0.05, 0.9],
};